var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A561ED08-3C69-45C5-A2FA-FA271E50563F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-111.000000, -1800.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Barcode",
    transform: "translate(111.000000, 1800.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Columns-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    transform: "translate(22.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-64",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 104,
    height: 66
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-52",
    transform: "translate(21.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-51",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.01081081,
    y: 0,
    width: 1.00540541,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-105",
    x: 6.36756757,
    y: 0,
    width: 1.00540541,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-109",
    x: 15.4162162,
    y: 0,
    width: 1.00540541,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-121",
    x: 39.5459459,
    y: 0,
    width: 1.00540541,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-125",
    x: 45.9135135,
    y: 0,
    width: 1.00540541,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-106",
    x: 7.70810811,
    y: 0,
    width: 1.00540541,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-110",
    x: 16.7567568,
    y: 0,
    width: 1.00540541,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-122",
    x: 40.8864865,
    y: 0,
    width: 1.00540541,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-126",
    x: 47.2540541,
    y: 0,
    width: 1.00540541,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-117",
    x: 27.4810811,
    y: 0,
    width: 1.00540541,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-107",
    x: 9.04864865,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-111",
    x: 18.0972973,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-123",
    x: 42.227027,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-127",
    x: 48.5945946,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-118",
    x: 28.8216216,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-129",
    x: 53.2864865,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-108",
    x: 11.0594595,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-112",
    x: 20.1081081,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-124",
    x: 44.2378378,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-128",
    x: 50.6054054,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-119",
    x: 30.8324324,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-130",
    x: 55.2972973,
    y: 0,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-104",
    x: 3.68648649,
    y: 0,
    width: 1.67567568,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-113",
    x: 12.7351351,
    y: 0,
    width: 1.67567568,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-114",
    x: 22.1189189,
    y: 0,
    width: 1.67567568,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-120",
    x: 32.8432432,
    y: 0,
    width: 1.67567568,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-131",
    x: 57.3081081,
    y: 0,
    width: 1.67567568,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-115",
    x: 24.4648649,
    y: 0,
    width: 1.67567568,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-116",
    x: 35.8594595,
    y: 0,
    width: 1.67567568,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-132",
    x: 60.3243243,
    y: 0,
    width: 1.67567568,
    height: 30
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.0867378,35.9479306 L22.0867378,33 L21.8532904,33 C21.7902328,33.1268358 21.6829007,33.2576769 21.531294,33.3925234 C21.3796874,33.5273698 21.2025894,33.6421896 21,33.7369826 L21,33.7369826 L21,34.0854473 C21.1126987,34.0440587 21.2398202,33.981976 21.3813645,33.8991989 C21.5229087,33.8164219 21.6372845,33.7336449 21.7244918,33.6508678 L21.7244918,33.6508678 L21.7244918,35.9479306 L22.0867378,35.9479306 Z M24.9182934,35.9479306 L24.9182934,35.6014686 L23.4713222,35.6014686 C23.5115717,35.5360481 23.5625545,35.4709613 23.6242705,35.4062083 C23.6859864,35.3414553 23.8255182,35.2182911 24.0428658,35.0367156 C24.3031462,34.817757 24.4893003,34.6455274 24.6013282,34.5200267 C24.7133561,34.394526 24.7935198,34.2750334 24.8418193,34.1615487 C24.8901187,34.0480641 24.9142685,33.9325768 24.9142685,33.8150868 C24.9142685,33.5841121 24.8317569,33.3905207 24.6667337,33.2343124 C24.5017106,33.0781041 24.2776548,33 23.9945663,33 C23.7141611,33 23.4907761,33.0724299 23.3244114,33.2172897 C23.1580466,33.3621495 23.0621185,33.5727637 23.0366271,33.8491322 L23.0366271,33.8491322 L23.4089354,33.8871829 C23.4102771,33.7029372 23.4632723,33.558745 23.5679211,33.4546061 C23.6725699,33.3504673 23.8121017,33.2983979 23.9865164,33.2983979 C24.1515395,33.2983979 24.2853693,33.3474633 24.3880056,33.4455941 C24.490642,33.543725 24.5419602,33.664219 24.5419602,33.8070761 C24.5419602,33.9432577 24.4856108,34.0877837 24.3729121,34.2406542 C24.2602133,34.3935247 24.0435366,34.6008011 23.7228819,34.8624833 C23.5162675,35.0307076 23.3582881,35.1789052 23.2489434,35.3070761 C23.1395988,35.435247 23.060106,35.5654206 23.0104649,35.6975968 C22.9796069,35.7777036 22.9655196,35.8611482 22.9682029,35.9479306 L22.9682029,35.9479306 L24.9182934,35.9479306 Z M26.2465285,36 C26.5336419,36 26.7711142,35.9108812 26.9589455,35.7326435 C27.1467767,35.5544059 27.2406923,35.3371162 27.2406923,35.0807744 C27.2406923,34.8911883 27.1923928,34.7333111 27.0957939,34.6071429 C26.999195,34.4809746 26.8636882,34.3978638 26.6892735,34.3578104 C26.8234387,34.2963952 26.9247333,34.2136182 26.9931576,34.1094793 C27.0615818,34.0053405 27.0957939,33.8898531 27.0957939,33.7630174 C27.0957939,33.629506 27.0599047,33.5033378 26.9881264,33.3845127 C26.916348,33.2656876 26.8127054,33.1718959 26.6771986,33.1031375 C26.5416918,33.0343792 26.3934393,33 26.2324411,33 C25.9989938,33 25.8037835,33.0664219 25.6468102,33.1992657 C25.489837,33.3321095 25.3892131,33.5193591 25.3449386,33.7610147 L25.3449386,33.7610147 L25.7071845,33.8251001 C25.7340176,33.6488652 25.7943919,33.5166889 25.8883075,33.4285714 C25.9822231,33.3404539 26.0996176,33.2963952 26.240491,33.2963952 C26.3827061,33.2963952 26.498759,33.3397864 26.5886496,33.4265688 C26.6785403,33.5133511 26.7234856,33.6228304 26.7234856,33.7550067 C26.7234856,33.9218959 26.6617696,34.0453939 26.5383377,34.1255007 C26.4149057,34.2056075 26.2760448,34.2456609 26.1217549,34.2456609 C26.1069967,34.2456609 26.0875428,34.2443258 26.063393,34.2416555 L26.063393,34.2416555 L26.0231435,34.5580774 C26.125109,34.5313752 26.2103039,34.518024 26.2787281,34.518024 C26.4464346,34.518024 26.5846247,34.5717623 26.6932985,34.679239 C26.8019722,34.7867156 26.8563091,34.923231 26.8563091,35.088785 C26.8563091,35.2623498 26.7976119,35.4078772 26.6802173,35.5253672 C26.5628228,35.6428571 26.4189307,35.7016021 26.248541,35.7016021 C26.1049842,35.7016021 25.9832294,35.6565421 25.8832763,35.5664219 C25.7833233,35.4763017 25.7125512,35.3291055 25.67096,35.1248331 L25.67096,35.1248331 L25.308714,35.1728972 C25.3328638,35.417223 25.4304689,35.6161549 25.6015295,35.7696929 C25.7725901,35.923231 25.9875897,36 26.2465285,36 Z M29.1223586,35.9479306 L29.1223586,35.2449933 L29.5208291,35.2449933 L29.5208291,34.9145527 L29.1223586,34.9145527 L29.1223586,33.012016 L28.8265245,33.012016 L27.4801771,34.9145527 L27.4801771,35.2449933 L28.7601127,35.2449933 L28.7601127,35.9479306 L29.1223586,35.9479306 Z M28.7601127,34.9145527 L27.8363856,34.9145527 L28.7601127,33.5907877 L28.7601127,34.9145527 Z M30.8390018,35.9979973 C31.1663648,35.9979973 31.4246327,35.8791722 31.6138056,35.641522 C31.7694372,35.4479306 31.847253,35.2182911 31.847253,34.9526035 C31.847253,34.6735648 31.758704,34.4452603 31.581606,34.2676903 C31.4045079,34.0901202 31.1871604,34.0013351 30.9295633,34.0013351 C30.7350238,34.0013351 30.5492051,34.0627503 30.3721071,34.1855808 L30.3721071,34.1855808 L30.5310928,33.3965287 L31.708392,33.3965287 L31.708392,33.0520694 L30.241296,33.0520694 L29.9555243,34.5600801 L30.2956329,34.6041389 C30.349299,34.5200267 30.4230898,34.4516021 30.5170054,34.3988652 C30.610921,34.3461282 30.7162407,34.3197597 30.8329644,34.3197597 C31.0207956,34.3197597 31.1727376,34.3791722 31.2887905,34.4979973 C31.4048434,34.6168224 31.4628698,34.7790387 31.4628698,34.9846462 C31.4628698,35.2009346 31.4024955,35.3744993 31.2817468,35.5053405 C31.1609982,35.6361816 31.0134165,35.7016021 30.8390018,35.7016021 C30.6941034,35.7016021 30.5703361,35.6552069 30.4676997,35.5624166 C30.3650634,35.4696262 30.2996579,35.3311081 30.2714832,35.1468625 L30.2714832,35.1468625 L29.891125,35.1789052 C29.9152747,35.4259012 30.012209,35.6241656 30.181928,35.7736983 C30.3516469,35.923231 30.5706715,35.9979973 30.8390018,35.9979973 Z M33.1915878,35.9979973 C33.3686859,35.9979973 33.5270007,35.9559413 33.6665325,35.8718291 C33.8060643,35.787717 33.9157443,35.6665554 33.9955725,35.5083445 C34.0754008,35.3501335 34.115315,35.1789052 34.115315,34.9946595 C34.115315,34.7142857 34.0304555,34.4856475 33.8607366,34.308745 C33.6910176,34.1318425 33.4854095,34.0433912 33.2439123,34.0433912 C33.1057221,34.0433912 32.9735695,34.0754339 32.8474542,34.1395194 C32.721339,34.2036048 32.6146777,34.3017356 32.5274703,34.4339119 C32.5301536,34.1401869 32.5643657,33.9138852 32.6301067,33.7550067 C32.6958476,33.5961282 32.7857382,33.4753004 32.8997786,33.3925234 C32.986986,33.3284379 33.0882807,33.2963952 33.2036627,33.2963952 C33.3472194,33.2963952 33.4679681,33.3477971 33.5659086,33.4506008 C33.6249413,33.5146862 33.6705575,33.61749 33.7027571,33.759012 L33.7027571,33.759012 L34.0629905,33.7309746 C34.0334742,33.5026702 33.9445898,33.323765 33.7963373,33.194259 C33.6480848,33.064753 33.4579057,33 33.2258,33 C32.9145368,33 32.6670021,33.1121495 32.4831958,33.3364486 C32.2725565,33.5941255 32.1672369,34.0066756 32.1672369,34.5740988 C32.1672369,35.0814419 32.2624941,35.4455941 32.4530087,35.6665554 C32.6435232,35.8875167 32.8897162,35.9979973 33.1915878,35.9979973 Z M33.1855504,35.7016021 C33.0809016,35.7016021 32.9809485,35.6718959 32.8856913,35.6124833 C32.790434,35.5530708 32.7163078,35.4666222 32.6633125,35.3531375 C32.6103173,35.2396529 32.5838197,35.1208278 32.5838197,34.9966622 C32.5838197,34.8070761 32.6408399,34.6538718 32.7548803,34.5370494 C32.8689206,34.420227 33.0077816,34.3618158 33.1714631,34.3618158 C33.3364862,34.3618158 33.4733347,34.420227 33.5820085,34.5370494 C33.6906822,34.6538718 33.7450191,34.8137517 33.7450191,35.0166889 C33.7450191,35.2276368 33.6900114,35.394526 33.579996,35.5173565 C33.4699805,35.6401869 33.3384987,35.7016021 33.1855504,35.7016021 Z M35.2845643,35.9479306 C35.3046891,35.6555407 35.3509761,35.3865154 35.4234252,35.1408545 C35.5240491,34.7923899 35.6665996,34.453271 35.8510767,34.123498 C36.0355538,33.793725 36.2217079,33.5293725 36.4095391,33.3304406 L36.4095391,33.3304406 L36.4095391,33.0500668 L34.4996981,33.0500668 L34.4996981,33.3965287 L35.9446569,33.3965287 C35.7608506,33.6048064 35.5874421,33.8608144 35.4244315,34.1645527 C35.2614208,34.4682911 35.1363118,34.7837116 35.0491044,35.1108144 C34.9618971,35.4379172 34.9162809,35.7169559 34.912256,35.9479306 L34.912256,35.9479306 L35.2845643,35.9479306 Z M37.7357617,35.9979973 C38.0269001,35.9979973 38.2616891,35.9125501 38.4401288,35.7416555 C38.6185685,35.570761 38.7077883,35.3598131 38.7077883,35.1088117 C38.7077883,34.9272363 38.6604951,34.771028 38.5659086,34.6401869 C38.4713222,34.5093458 38.3334675,34.4145527 38.1523445,34.3558077 C38.2985846,34.3010681 38.4075937,34.2232977 38.4793721,34.1224967 C38.5511505,34.0216956 38.5870396,33.9032043 38.5870396,33.7670227 C38.5870396,33.5534045 38.508553,33.3721629 38.3515798,33.2232977 C38.1946066,33.0744326 37.9873214,33 37.7297243,33 C37.4734688,33 37.2681961,33.0727637 37.1139062,33.2182911 C36.9596163,33.3638184 36.8824713,33.5433912 36.8824713,33.7570093 C36.8824713,33.8985314 36.9186959,34.0200267 36.9911451,34.1214953 C37.0635943,34.222964 37.1749514,34.3010681 37.3252163,34.3558077 C37.145435,34.4025367 37.0069095,34.4903204 36.9096398,34.6191589 C36.81237,34.7479973 36.7637352,34.9078772 36.7637352,35.0987984 C36.7637352,35.3551402 36.852955,35.5690921 37.0313946,35.7406542 C37.2098343,35.9122163 37.4446233,35.9979973 37.7357617,35.9979973 Z M37.7377742,34.2176235 C37.5942175,34.2176235 37.4774938,34.1735648 37.3876031,34.0854473 C37.2977125,33.9973298 37.2527672,33.8838451 37.2527672,33.7449933 C37.2527672,33.6221629 37.2983833,33.5166889 37.3896156,33.4285714 C37.4808479,33.3404539 37.5955591,33.2963952 37.7337492,33.2963952 C37.8705977,33.2963952 37.9849735,33.3414553 38.0768766,33.4315754 C38.1687798,33.5216956 38.2147313,33.6328438 38.2147313,33.76502 C38.2147313,33.8918558 38.1701214,33.9989987 38.0809016,34.0864486 C37.9916818,34.1738985 37.877306,34.2176235 37.7377742,34.2176235 Z M37.7397867,35.7016021 C37.6284296,35.7016021 37.5244516,35.6752336 37.4278527,35.6224967 C37.3312538,35.5697597 37.2584692,35.4953271 37.2094989,35.3991989 C37.1605286,35.3030708 37.1360435,35.2036048 37.1360435,35.1008011 C37.1360435,34.9325768 37.1920574,34.7923899 37.3040853,34.6802403 C37.4161132,34.5680908 37.5573221,34.512016 37.7277118,34.512016 C37.9021265,34.512016 38.0473603,34.5687583 38.1634132,34.682243 C38.279466,34.7957276 38.3374925,34.9392523 38.3374925,35.1128171 C38.3374925,35.2837116 38.2811431,35.4245661 38.1684444,35.5353805 C38.0557456,35.6461949 37.9128597,35.7016021 37.7397867,35.7016021 Z M39.9434494,35.9979973 C40.1607969,35.9979973 40.3503052,35.9399199 40.5119742,35.823765 C40.6736433,35.7076101 40.7953981,35.5383845 40.8772389,35.3160881 C40.9590796,35.0937917 41,34.7950601 41,34.4198932 C41,34.0594126 40.9587442,33.7840454 40.8762326,33.5937917 C40.7937211,33.4035381 40.6729724,33.2570093 40.5139867,33.1542056 C40.355001,33.0514019 40.1795801,33 39.9877239,33 C39.7220769,33 39.5010398,33.0907877 39.3246126,33.2723632 C39.1481854,33.4539386 39.0599718,33.6935915 39.0599718,33.9913218 C39.0599718,34.2797063 39.1444959,34.512016 39.313544,34.688251 C39.4825921,34.864486 39.6892064,34.9526035 39.933387,34.9526035 C40.079627,34.9526035 40.2154692,34.9168892 40.3409137,34.8454606 C40.4663581,34.774032 40.5653049,34.6809079 40.6377541,34.5660881 C40.6390957,34.5981308 40.6397666,34.6221629 40.6397666,34.6381842 C40.6397666,34.787717 40.6216543,34.9345794 40.5854297,35.0787717 C40.5492051,35.222964 40.5042597,35.3374499 40.4505937,35.4222296 C40.3969276,35.5070093 40.328168,35.5747664 40.2443148,35.6255007 C40.1604615,35.676235 40.0628564,35.7016021 39.9514993,35.7016021 C39.8213591,35.7016021 39.7146978,35.6648865 39.6315154,35.5914553 C39.548333,35.518024 39.4919836,35.3998665 39.4624673,35.2369826 L39.4624673,35.2369826 L39.1143087,35.2690254 C39.143825,35.5 39.2317032,35.679239 39.3779432,35.8067423 C39.5241833,35.9342457 39.7126853,35.9979973 39.9434494,35.9979973 Z M40.021936,34.6341789 C39.8555712,34.6341789 39.715704,34.5757677 39.6023345,34.4589453 C39.4889649,34.3421228 39.4322801,34.1902537 39.4322801,34.0033378 C39.4322801,33.7950601 39.4919836,33.6255007 39.6113906,33.4946595 C39.7307976,33.3638184 39.8710002,33.2983979 40.0319984,33.2983979 C40.18763,33.2983979 40.3207889,33.3591455 40.4314751,33.4806409 C40.5421614,33.6021362 40.5975045,33.7663551 40.5975045,33.9732977 C40.5975045,34.1802403 40.5435031,34.3421228 40.4355001,34.4589453 C40.3274971,34.5757677 40.1896424,34.6341789 40.021936,34.6341789 Z",
    id: 123456789,
    fill: "#464646",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/Barcode.af2b6b4183504c8e890f6c1ce0eefa81.svg";
export { ForwardRef as ReactComponent };